import { z } from 'zod';
import { customerTypeSchema } from './customer.schema';
import { listQuerySchema } from '../common/pagination';

export const createContactSchema = z.object({
  firstName: z.string().trim().min(1).max(120),
  lastName: z.string().trim().min(1).max(120),
  email: z.string().trim().email().max(200).optional(),
  phone: z.string().trim().max(50).optional(),
  mobile: z.string().trim().max(50).optional(),
  position: z.string().trim().max(120).optional(),
  department: z.string().trim().max(120).optional(),
  notes: z.string().trim().max(2000).optional(),
  isPrimary: z.boolean().default(false),
});
export type CreateContactInput = z.infer<typeof createContactSchema>;

export const updateContactSchema = createContactSchema.partial().extend({
  /** Neue Adresse (Kunde/Lieferant) — verschiebt den Ansprechpartner. */
  customerId: z.string().uuid().optional(),
});
export type UpdateContactInput = z.infer<typeof updateContactSchema>;

export const contactResponseSchema = z.object({
  id: z.string().uuid(),
  customerId: z.string().uuid(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().nullable(),
  phone: z.string().nullable(),
  mobile: z.string().nullable(),
  position: z.string().nullable(),
  department: z.string().nullable(),
  notes: z.string().nullable(),
  isPrimary: z.boolean(),
  /** Zusatzfelder aus Altdaten-Import (Ansprechpartner). */
  salutation: z.string().nullable(),
  title: z.string().nullable(),
  gender: z.string().nullable(),
  birthDate: z.string().nullable(),
  language: z.string().nullable(),
  fax: z.string().nullable(),
  phoneInternal: z.string().nullable(),
  website: z.string().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type ContactResponse = z.infer<typeof contactResponseSchema>;

/** Eintrag im globalen Ansprechpartner-Verzeichnis (mit Adress-Bezug). */
export const contactDirectoryItemSchema = contactResponseSchema.extend({
  customerName: z.string(),
  customerType: customerTypeSchema,
});
export type ContactDirectoryItem = z.infer<typeof contactDirectoryItemSchema>;

/** Listen-Query fürs Ansprechpartner-Verzeichnis: Pagination + Filter. */
export const contactDirectoryQuerySchema = listQuerySchema.extend({
  customerType: customerTypeSchema.optional(),
  isPrimary: z.coerce.boolean().optional(),
});
export type ContactDirectoryQuery = z.infer<typeof contactDirectoryQuerySchema>;
